/* Provisional editorial affinities, not verified book metadata. Replace this matrix
   or add approved Recommendation blocks in Header > Daniverse — Shop + Oracle. */
(() => {
  const data = {
    version: 1,
    provisional: true,
    questions: [
      { id: 'damage', label: 'Your damage', title: 'What are you craving tonight?', helper: 'No wrong answers. Only increasingly questionable decisions.', answers: [
        { id: 'possess', label: 'Possess me', art: 'snake', tags: ['possess'], signals: { possess: 6 } },
        { id: 'ruin', label: 'Ruin me', art: 'heart', tags: ['ruin'], signals: { ruin: 6 } },
        { id: 'laugh', label: 'Make me laugh while everything burns', art: 'mask', tags: ['chaos'], signals: { chaos: 6 } },
        { id: 'monsters', label: 'Give me monsters', art: 'wolf', tags: ['monsters'], signals: { monsters: 6 } },
        { id: 'harem', label: 'Hand me the entire harem', art: 'crown', tags: ['why_choose'], signals: { why_choose: 6 } },
        { id: 'surprise', label: 'Surprise me — I make poor decisions beautifully', art: 'fate', tags: ['surprise'], signals: { surprise: 1 } }
      ] },
      { id: 'danger', label: 'Danger level', title: 'How far into the dark?', helper: 'You set the limits. The monsters can wait.', answers: [
        { id: 'curious', label: 'Let me taste the temptation', art: 'orb', tags: ['curious'], signals: { curious: 3 } },
        { id: 'reckless', label: 'I came for the red flags', art: 'heart', tags: ['reckless'], signals: { reckless: 3 } },
        { id: 'feral', label: 'Let the villain win', art: 'wolf', tags: ['feral'], signals: { feral: 3 } }
      ] },
      { id: 'commitment', label: 'Commitment', title: 'How deep is this obsession?', helper: 'A first taste, a long night, or a beautiful downfall.', answers: [
        { id: 'taste', label: 'Just a taste. For now.', art: 'book', tags: ['sample'], signals: { sample: 3 } },
        { id: 'story', label: 'One more chapter', art: 'fate', tags: ['story'], signals: { story: 3 } },
        { id: 'all', label: 'Give me the whole kingdom', art: 'coins', tags: ['series'], signals: { series: 3 } }
      ] }
    ]
  };
  // DOM-free scoring: merchant signals stay data, never executable code.
  const score = (questions, selections, recommendations) => {
    const signals = {};
    questions.forEach(q => {
      const answer = q.answers.find(a => a.id === selections[q.id]);
      Object.entries(answer?.signals || {}).forEach(([key, weight]) => {
        if (Number.isFinite(Number(weight))) signals[key] = (signals[key] || 0) + Number(weight);
      });
    });
    return recommendations.map((item, index) => ({ item, index, score: Object.entries(item.weights || {}).reduce((sum, [key, weight]) => sum + (signals[key] || 0) * (Number(weight) || 0), 0) }))
      .sort((a, b) => b.score - a.score || a.index - b.index)[0]?.item;
  };
  window.MDOracle = Object.freeze({ data, score });
})();
